import { decimalToTime, timeToDecimal } from "./timeConversion";

/**
 * Genera las opciones de hora de FIN ("Hasta") en intervalos de 15 min.
 * @param lastAvailableTime Piso dinamico (hora de inicio + 0.25, o 24 si no hay inicio).
 * @param openTime Hora de apertura del local en formato decimal 24h (default 0 = medianoche).
 * @param closeTime Hora de cierre del local en formato decimal 24h (default 24 = sin tope).
 * @param keepValue Valor ya guardado ("HH:MM AM/PM"); se preserva como opcion aunque
 *   exceda el cierre del local, siempre que sea coherente con la hora de inicio (piso).
 *   Si el valor es anterior al inicio (inconsistente), NO se preserva y se limpia.
 *
 * El cierre del local SI es seleccionable como fin (closeTime inclusivo).
 */
export const getEndSchedulesList = (
  lastAvailableTime: number,
  openTime: number = 0,
  closeTime: number = 24,
  keepValue: string = ""
) => {
  const startTime = Math.max(lastAvailableTime, openTime);
  const decimals: number[] = [];
  for (let index = startTime; index <= closeTime && index < 24; index += 0.25) {
    decimals.push(Number(index.toFixed(2)));
  }
  // Preservar el valor guardado aunque exceda el cierre del local (si es coherente con el inicio).
  const keep = timeToDecimal(keepValue);
  if (keep !== null && keep >= lastAvailableTime && keep < 24 && !decimals.includes(keep)) {
    decimals.push(keep);
    decimals.sort((a, b) => a - b);
  }
  return decimals.map(decimalToTime);
};
